import React from 'react'
import {Link as RouteLink} from 'gatsby'
import classes from 'classnames'

function Link(props) {
  const {children, stylings, ...link} = props
  return <RouteLink {...link} className={classes('Link', stylings)}>{children}</RouteLink>
}

export default Link
